// Refresh only the collection section, keeping Shopify prices, stock and order authoritative.
(() => {
  if (window.ChaponCollectionFacets) {
    window.ChaponCollectionFacets.enhance();
    return;
  }
  const enhance = () => document.querySelectorAll('[data-collection-facets]').forEach(toolbar => toolbar.setAttribute('data-collection-enhanced', ''));
  let pending;
  async function update(url, toolbar, push = true) {
    pending?.abort();
    const controller = new AbortController();
    pending = controller;
    const section = toolbar.closest('[data-section="main-collection"]');
    section.setAttribute('aria-busy', 'true');
    const target = new URL(url, window.location.origin);
    target.searchParams.delete('page');
    const request = new URL(target);
    request.searchParams.set('section_id', toolbar.dataset.sectionId);
    const focus = document.activeElement;
    const focusedName = focus?.name;
    const focusedValue = focus?.value;
    const focusedFilter = focus?.dataset.filterKey;
    try {
      const response = await fetch(request, { signal: controller.signal });
      if (!response.ok) throw new Error(`Collection response: ${response.status}`);
      const document = new DOMParser().parseFromString(await response.text(), 'text/html');
      const replacement = document.querySelector('[data-section="main-collection"]');
      if (!replacement) throw new Error('Collection section is missing');
      section.replaceWith(replacement);
      if (push) window.history.pushState({}, '', target);
      enhance();
      const controls = replacement.querySelectorAll('a[data-filter-key], input, select');
      [...controls].find(control => focusedFilter ? control.dataset.filterKey === focusedFilter : focusedName && control.name === focusedName && control.value === focusedValue)?.focus({ preventScroll: true });
    } catch (error) {
      if (error.name === 'AbortError') return;
      console.error('Collection refresh failed; loading the complete page.', error);
      window.location.assign(target);
    } finally {
      if (pending === controller) {
        pending = null;
        section.removeAttribute('aria-busy');
      }
    }
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('a[data-filter-url]');
    const toolbar = link?.closest('[data-collection-facets]');
    if (!toolbar || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    update(link.href, toolbar);
  });
  document.addEventListener('change', event => {
    const control = event.target;
    const toolbar = control.closest('[data-collection-facets]');
    if (!toolbar) return;
    if (control.dataset.filterUrl) update(control.dataset.filterUrl, toolbar);
    else if (control.name === 'sort_by') {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', control.value);
      update(url, toolbar);
    }
  });
  document.addEventListener('submit', event => {
    const toolbar = event.target.closest('[data-collection-facets]');
    if (!toolbar) return;
    event.preventDefault();
    const url = new URL(event.target.action);
    url.search = new URLSearchParams(new FormData(event.target)).toString();
    update(url, toolbar);
  });
  window.addEventListener('popstate', () => {
    const toolbar = document.querySelector('[data-collection-facets]');
    if (toolbar) update(window.location.href, toolbar, false);
  });
  window.ChaponCollectionFacets = { update, enhance };
  enhance();
})();
